import { Radio } from "antd";
import { useQuote } from "../QuoteProvider";
import QuoteRadio from "../QuoteRadio";
import { uploadedImagePath } from "../../../utils/uploadedImage";
import { useEffect } from "react";

export type Option = {
  value: string;
  label: string;
};

type StepSelectLocationParams = {
  selectLocation: (location: string) => void;
};

const StepSelectLocation = ({ selectLocation }: StepSelectLocationParams) => {
  const quoteData = useQuote();

  const onChangeLocationOption = (e: any) => {
    selectLocation(e.target.value);
  };

  // Clear the pick on mount ONLY when the stored value isn't one of the
  // options on screen (stale id from a resumed/shared quote). It used to clear
  // unconditionally, so navigating BACK to this step wiped a valid selection
  // and the patient had to choose again. Latent today — prod runs a single
  // location, so QuoteApp never puts this step in stepOrder — but it is the
  // cheap fix, not a redesign.
  useEffect(() => {
    const isValidSelection = quoteData.locationOptions.some(
      (option: { value: string }) => option.value === quoteData.location,
    );
    if (!isValidSelection) {
      quoteData.setLocation("");
    }
    // Mount-only by design: this reconciles the stored value once, on arrival.
    // (The react-hooks plugin isn't installed here, so no disable directive —
    // see the #395/#399 deploy incident.)
  }, []);

  const optionsRender = quoteData.locationOptions.map((option: any, index) => {
    return (
      <div
        className="location-container"
        style={{ width: "30%" }}
        key={option.label}
      >
        <QuoteRadio
          img={uploadedImagePath(option.image)}
          isSelected={option.value === quoteData.location}
          label={option.label}
          value={option.value}
          key={option.label}
        />
      </div>
    );
  });

  return (
    <div style={{ paddingTop: "45px" }}>
      <div>
        <Radio.Group
          value={quoteData.location}
          onChange={onChangeLocationOption}
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          {optionsRender}
        </Radio.Group>
      </div>
    </div>
  );
};

export default StepSelectLocation;
